<template>
    <div>
      <div style="font-size: 10px">单位（万元）</div>
      <div class="asset-main">
        <div class="asset-module">
          <div class="asset-item">
            <span>在手订单({{assetDict['在手订单'].count}})</span>
            <span>{{assetDict['在手订单'].amount}}</span>
          </div>
          <div class="asset-item">
            <span>变现存量({{assetDict['变现存量'].count}})</span>
            <span>{{assetDict['变现存量'].amount}}</span>
          </div>
          <div class="asset-item">
            <span>应收账款({{assetDict['应收账款'].count}})</span>
            <span>{{assetDict['应收账款'].amount}}</span>
          </div>
          <div class="asset-item">
            <span>已验收未开票({{assetDict['已验收未开票'].count}})</span>
            <span>{{assetDict['已验收未开票'].amount}}</span>
          </div>
        </div>
        <div class="asset-module">
          <div class="asset-item">
            <span>未关闭商机({{assetDict['未关闭商机'].count}})</span>
            <span>{{assetDict['未关闭商机'].amount}}</span>
          </div>
        </div>
      </div>
      
    </div>
</template>

<script>
import {getClientAssets} from "@/api/api"
export default {
    name: "ClientAsset",
    props: {
      clientName: {
        type: String,
        required: true
      }
    },
    data(){
        return {
            assetDict: {
              "变现存量": {"amount": "", "count": ""},
              "在手订单": {"amount": "", "count": ""},
              "已验收未开票": {"amount": "", "count": ""},
              "应收账款": {"amount": "", "count": ""},
              "未关闭商机": {"amount": "", "count": ""},
            }
        }
    },

    mounted() {
      this.refresh()
    },

    methods: {
      async getData() {
        let postData = {
          client_name: this.clientName
        }
        let res = await getClientAssets(postData)
        this.assetDict = res.respData
      },

      async refresh() {
        await this.getData()
      }
    }
}

</script>
<style scoped>
  .asset-item{
    padding-top: 30px;
    font-size: 14px;
  }

  .asset-item > span:first-child{
    display: inline-block;
    min-width: 150px;
  }

  .asset-main{
    display: flex;
  }

  .asset-module{
    margin-right: 200px;
  }

</style>